import axios        from 'axios';
import {router}     from '../../router/router.js'
import {SERVER_PATH} from '../../config.js'

const state = {
    tooltips: [],
    buildExceptions: [
        'id',
        'author_id'
    ],
    miningProfit:   {},
    lastRoute:      'builder/' + 'home',
    token:          localStorage.getItem('usertoken')       || null,
    refreshToken:   localStorage.getItem('refreshToken')    || null,
    loggedInState:  localStorage.getItem('logged_in')       || 'false',
    error:          null,
    user:           localStorage.getItem('user')            || null,
    buildAdded:     null,
    userBuilds:     null,
    buildsLoaded:   true,
    profitListLoaded:true,
    stillHover:     false
};

const getters = {
    getTooltips:        (state) => state.tooltips,
    getProfitListLoaded:(state) => state.profitListLoaded,
    getProfitability:   (state) => state.miningProfit,
    getUserBuilds:      (state) => state.userBuilds,
    getUser:            (state) => state.user,
    getToken:           (state) => state.token,
    lastRoute:          (state) => state.lastRoute,
    loggedIn:           (state) => state.loggedInState,
    getError:           (state) => state.error,
    getBuildAdded:      (state) => state.buildAdded,
    ifBuildsLoaded:     (state) => state.buildsLoaded,
};

const actions = {
    async showTooltip({commit, state}, tooltip){
        if(tooltip){
            commit('HOVER_TRUE')
            setTimeout(() => {
                if(state.stillHover == true){
                    commit('SHOW_TOOLTIP', tooltip)
                }
            }, 500) 
        }
    },
    hideTooltip({commit}, tooltip){
        if(tooltip){
            commit('HIDE_TOOLTIP', tooltip)
        }
    },
    async fetchMiningProfitability({commit}){
        console.log('fetching mining profit. list: ')
        commit('PROFIT_LIST_LOADED', false)
            await axios({
                url: `http://api2.nicehash.com/main/api/v2/public/stats/global/current`,
                method: "get",
                headers: {
                    'Content-Type': `application/json`
                }
            })
            .then((response) => {
                console.log('received mining prof response', response.data)
                commit('RECORD_MINING_PROFITABILITY', response.data.Build)
                commit('PROFIT_LIST_LOADED', true)
                console.log(response)
            })
            .catch((e) => {
                commit('PROFIT_LIST_LOADED', true)
                console.log(e)
            })
    },
    async fetchUserBuilds({commit}, user_id){
        console.log('fetching user builds with id: ', user_id)
        commit('BUILDS_LOADED', false)
        if(user_id !== null || user_id !== ''){
            await axios({
                url: `${SERVER_PATH}builds/builds/?author_id=${user_id}`,
                method: "get",
                headers: {
                    'Content-Type': `application/json`,
                    'Authorization': `Bearer ${localStorage.usertoken}`,
                    'alg': "HS256",
                    'typ': "JWT"
                }
            })
            .then((response) => {
                console.log('received builds', response.data)
                commit('RECORD_USER_BUILDS', response.data.Build)
                commit('BUILDS_LOADED', true)
                console.log(response)
            })
            .catch((e) => {
                commit('BUILDS_LOADED', true)
                console.log(e)
            })
        }
    },
    async login(context, credentials) {
        console.log('LOGIN....', SERVER_PATH)
        return new Promise((resolve, reject) => {    
             axios.post(`${SERVER_PATH}users/auth/login`, {
                email: credentials.email,
                password: credentials.password
            })
            .then((response) => {
                console.log(response)
                const token =           response.data.token
                const refreshToken =    response.data.refreshToken
                localStorage.setItem(   'usertoken', token)
                localStorage.setItem(   'refreshToken', refreshToken)
                console.log(localStorage.usertoken)
                // context.commit(         'retrieveToken', token)
                resolve(response)
                console.log('login success, redirecting...')
                router.push({path: '/users/dashboard'})
            })
            .catch((err) => {
                console.log(err)
                reject(err)
            })
        })
    },
    async register({commit}, credentials){
        await axios.post(`${SERVER_PATH}users/auth/register`,
            {
                email: credentials.email,
                password: credentials.password,
                username: credentials.username,
                first_name: credentials.first_name,
                last_name: credentials.last_name
            })
            .then((response) => {
                console.log('register success, response: ', response)
                router.push({name: 'RegisterSuccess'})
            })
            .catch((err) => {
                commit('NEW_ERROR', err)
                console.log(err)
        })
    },
    async validate({commit}){
        return await axios({
            url: `${SERVER_PATH}users/auth/validate`,
            method: "post",
            headers: {
                'Content-Type': `application/json`,
                'Authorization': `Bearer ${localStorage.usertoken}`,
                'alg': "HS256",
                'typ': "JWT"
            }
        }) 
            .then((response) => {
                var user = response.data['User']
                console.log(user)
                commit('SET_USER', user)
                commit('LOGGED_IN')
                console.log('user logged in: ', localStorage.getItem('logged_in'))
               return response
            })
            .catch((err) => {
                commit('LOGGED_OUT')
            console.log(err)
        })
    },
    async update({commit}, data){
        console.log('update started, sending:')
        console.log(data)
        return await axios({
          url: `${SERVER_PATH}users/auth/update`, 
          method: 'post',
          headers: {
            'Content-Type': `application/json`,
            'Authorization': `Bearer ${localStorage.usertoken}`,
            'alg': "HS256",
            'typ': "JWT"
          },
          data: JSON.stringify(data)
        }).then((response) => {
          console.log('success')
          console.log(response.data.User)
          console.log('update successful')
          return response;
        }, (error) => {
          commit('NEW_ERROR', error)
          console.log(error)
        })
    },
    async logout({ commit }){
        localStorage.removeItem('usertoken')
        return  await axios({
            url: `${SERVER_PATH}users/auth/logout`,
            method: "post",
            headers: {
                'Content-Type': `application/json`,
                'Authorization': `Bearer ${localStorage.usertoken}`,
                'alg': "HS256",
                'typ': "JWT"
            },
            data: {
                refreshToken: state.refreshToken
            }
        }) 
            .then((response) => {
                commit('LOGGED_OUT', state)
                console.log(response)
               return response
            })
            .catch((err) => {
                console.log(err)
        })
    },
    async getLastRoute({ commit }, route){
        commit('newRoute', route)
    },
    async LoggedInCheck({ commit }, loggedIn){
        commit('checkIfLoggedIn', loggedIn)
    },
    setLoggedIn({commit}){
        commit('LOGGED_IN')
    },
    setLoggedOut({commit}, state){
        commit('LOGGED_OUT', state)
    },
    setError({commit}, error){
        commit('NEW_ERROR', error)
        console.log('error recorded', error)
    },
    setBuildAdded({commit}, message){
        commit('BUILD_ADDED', message)
    },
    checkBuildStatus(build){
        console.log('checkbuildstatus started, build: ', build)       
    }
};

const mutations = {
    PROFIT_LIST_LOADED(state, bool){
        state.profitListLoaded = bool
    },
    RECORD_MINING_PROFITABILITY(state, list){
        state.miningProfit = [...list]
    },
    BUILDS_LOADED(state, bool){
        state.buildsLoaded = bool
    },
    RECORD_USER_BUILDS(state, builds){
        // Loop Through List of Builds
        console.log('recording user builds ', builds)
        var essentials = [
            'processor',
            'motherboard',
            'ram',
            'psu',
            'storage',
            'case'
        ]
        var totalCost = 0;
        for (let i = 0; i < builds.length; i++) {
            for (const property in builds[i]) {
                if(property == 'case' && builds[i][property] !== null){
                   builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                }
                else if(property == 'processor' && builds[i][property] !== null){
                    builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                }
                else if(property == 'motherboard' && builds[i][property] !== null){
                    builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                }
                else {
                    if (builds[i][property] !== null && builds[i][property].imgUrl && JSON.parse(builds[i][property].imgUrl).length > 0){
                        builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                    }
                }
                if (typeof(builds[i][`${property}_id`]) == 'number' && property !== 'accessories'){
                    if(essentials.length==1){
                        essentials = []
                    }
                    else {
                        essentials.splice(1, essentials.indexOf(`${property}`))
                    }
                }
            }
            builds[i]['cost'] = totalCost
            if(essentials.length > 0){
                builds[i]['status'] = 'incomplete'
                console.log(builds[i]['status'])
                
            }
            else if (essentials.length == 0) {
                builds[i]['status'] = 'complete'
            }
        }
        state.userBuilds = builds;
        console.log('user builds recorded: ', builds)
    },
    SET_USER (state, user){
        state.user = user
        localStorage.setItem('user', JSON.stringify(user))
        console.log('localstorage: ', localStorage)
    },
    LOGGED_IN (state){
        localStorage.setItem('logged_in', true)
        state.loggedInState = 'true'
    },
    LOGGED_OUT (state){
        localStorage.removeItem('user')
        state.user = null
        state.token = null
        window.localStorage.removeItem('logged_in')
        state.loggedInState = 'false'
    },
    SHOW_TOOLTIP       (state, tooltip){
        var tooltips = [...state.tooltips]
        if(!tooltips.includes(tooltip) && state.stillHover == true){
           tooltips.push(tooltip)
        }
        state.tooltips  = tooltips
        console.log('tooltip ', tooltip , ' is added')
    },
    HIDE_TOOLTIP       (state, tooltip){
        var tooltips = [...state.tooltips]
        if(tooltips.includes(tooltip)){
           tooltips.splice(tooltips.indexOf(tooltip), 1)
        }
        state.tooltips  = tooltips
        state.stillHover = false
    },
    HOVER_TRUE:         (state)             => state.stillHover = true,
    NEW_ERROR:          (state, err)        => state.error = err,
    BUILD_ADDED:        (state, message)    => state.buildAdded = message,
    newRoute:           (state, route)      => state.lastRoute = route,
    checkIfLoggedIn:    (state, loggedIn)   => state.loggedInState = loggedIn,
    retrieveToken       (state, token) {
        state.token = token
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}